/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendChatMessagesRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {SendChatMessagesResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const sendChatMessages = (request: SendChatMessagesRequest, options?: CashRequestOptions) => post<SendChatMessagesRequest, SendChatMessagesResponse>("/2.0/cash/send-chat-messages", request, {...options, rejectOnError: true })